import React from 'react'

const Time = () => {
  return (
    <div>
       <p className='footer-title'>Opening Hours</p>
       <p className='text-decoration-underline mb-2'>Maternity</p>
       <p className='mb-1'>9AM-6PM (Mon-Sat)</p>
       <p>24/7 (Emergency)</p>
       <p className='text-decoration-underline mb-2'>Children</p>
       <p className='mb-1'>9AM-3PM (Mon-Sun)</p>
       <p>6PM-9PM (Mon-Sun)</p>
    </div>
  )
}

export default Time
